export default "__VITE_ASSET__DQxYFjKe__"